import { useForm } from 'react-hook-form';

import { CreateOrderInput, OrderType, TransactionStatus, TransactionType } from '@/generated/graphql';
import { todayDate } from '@/helpers/date';

export type TransactionForm = {
  portfolioId: string;
  stockId: string;
  type: TransactionType;
  status: TransactionStatus;
  order: CreateOrderInput;
};

type Props = {
  order?: CreateOrderInput | Partial<CreateOrderInput>;
};

export const useTransactionForm = ({ order }: Props = {}) => {
  const defaultValues = {
    order: {
      type: OrderType.Buy,
      date: todayDate,
      commissions: 0,
      exchangeRate: 1,
      ...order,
    },
  };

  return useForm<TransactionForm>({ defaultValues });
};
